import React from 'react';
// Custom sport-specific SVG icons for category cards.
// Strokes use currentColor so they inherit from parent text color.
interface IconProps {
  className?: string;
  strokeWidth?: number;
}
export const HockeyIcon = ({
  className,
  strokeWidth = 1.5
}: IconProps) => <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-306">
    {/* Hockey stick */}
    <path d="M10 8 L34 32 L38 36" data-id="element-307" />
    <path d="M34 32 L41 28" data-id="element-308" />
    {/* Puck */}
    <ellipse cx="14" cy="38" rx="7" ry="3" fill="currentColor" fillOpacity="0.15" data-id="element-309" />
    <ellipse cx="14" cy="38" rx="7" ry="3" data-id="element-310" />
    <line x1="7" y1="38" x2="7" y2="40" data-id="element-311" />
    <line x1="21" y1="38" x2="21" y2="40" data-id="element-312" />
    <path d="M7 40 Q14 43 21 40" data-id="element-313" />
  </svg>;
export const SoccerBallIcon = ({
  className,
  strokeWidth = 1.5
}: IconProps) => <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-314">
    {/* Ball outline */}
    <circle cx="24" cy="24" r="17" data-id="element-315" />
    {/* Pentagon panels */}
    <path d="M24 14 L31 19 L28 27 L20 27 L17 19 Z" fill="currentColor" fillOpacity="0.12" data-id="element-316" />
    <path d="M24 14 L31 19 L28 27 L20 27 L17 19 Z" data-id="element-317" />
    {/* Lines extending outward */}
    <line x1="24" y1="14" x2="24" y2="7" data-id="element-318" />
    <line x1="31" y1="19" x2="37" y2="14" data-id="element-319" />
    <line x1="28" y1="27" x2="34" y2="33" data-id="element-320" />
    <line x1="20" y1="27" x2="14" y2="33" data-id="element-321" />
    <line x1="17" y1="19" x2="11" y2="14" data-id="element-322" />
  </svg>;
export const FishingIcon = ({
  className,
  strokeWidth = 1.5
}: IconProps) => <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-323">
    {/* Fish body */}
    <path d="M8 24 Q14 14 26 16 Q36 18 40 24 Q36 30 26 32 Q14 34 8 24 Z" fill="currentColor" fillOpacity="0.12" data-id="element-324" />
    <path d="M8 24 Q14 14 26 16 Q36 18 40 24 Q36 30 26 32 Q14 34 8 24 Z" data-id="element-325" />
    {/* Tail */}
    <path d="M40 24 L44 18 L44 30 Z" fill="currentColor" fillOpacity="0.12" data-id="element-326" />
    <path d="M40 24 L44 18 L44 30 Z" data-id="element-327" />
    {/* Eye */}
    <circle cx="14" cy="22" r="1.2" fill="currentColor" data-id="element-328" />
    {/* Fin */}
    <path d="M22 18 L26 12 L28 18" data-id="element-329" />
  </svg>;
export const AccessoriesIcon = ({
  className,
  strokeWidth = 1.5
}: IconProps) => <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-330">
    {/* Gear bag */}
    <path d="M10 18 L38 18 L36 40 L12 40 Z" fill="currentColor" fillOpacity="0.12" data-id="element-331" />
    <path d="M10 18 L38 18 L36 40 L12 40 Z" data-id="element-332" />
    {/* Handle */}
    <path d="M18 18 L18 14 Q18 10 24 10 Q30 10 30 14 L30 18" data-id="element-333" />
    {/* Front pocket */}
    <line x1="15" y1="28" x2="33" y2="28" data-id="element-334" />
    <path d="M22 28 L22 34 L26 34 L26 28" data-id="element-335" />
  </svg>;
export const BaseballIcon = ({
  className,
  strokeWidth = 1.5
}: IconProps) => <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-336">
    <circle cx="24" cy="24" r="14" fill="currentColor" fillOpacity="0.1" data-id="element-337" />
    <circle cx="24" cy="24" r="14" data-id="element-338" />
    <path d="M13 18 Q24 22 35 18" data-id="element-339" />
    <path d="M13 30 Q24 26 35 30" data-id="element-340" />
    <line x1="15" y1="17" x2="14" y2="15" data-id="element-341" />
    <line x1="19" y1="19" x2="18.5" y2="17" data-id="element-342" />
    <line x1="24" y1="20" x2="24" y2="18" data-id="element-343" />
    <line x1="29" y1="19" x2="29.5" y2="17" data-id="element-344" />
    <line x1="33" y1="17" x2="34" y2="15" data-id="element-345" />
    <line x1="15" y1="31" x2="14" y2="33" data-id="element-346" />
    <line x1="19" y1="29" x2="18.5" y2="31" data-id="element-347" />
    <line x1="24" y1="28" x2="24" y2="30" data-id="element-348" />
    <line x1="29" y1="29" x2="29.5" y2="31" data-id="element-349" />
    <line x1="33" y1="31" x2="34" y2="33" data-id="element-350" />
  </svg>;
export const SoftballIcon = ({
  className,
  strokeWidth = 1.5
}: IconProps) => <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-351">
    <circle cx="24" cy="24" r="15" fill="currentColor" fillOpacity="0.1" data-id="element-352" />
    <circle cx="24" cy="24" r="15" data-id="element-353" />
    <path d="M11 28 Q24 14 37 20" data-id="element-354" />
    <line x1="15" y1="26.5" x2="14" y2="28.5" data-id="element-355" />
    <line x1="20" y1="22" x2="19" y2="24" data-id="element-356" />
    <line x1="25" y1="19" x2="24" y2="21" data-id="element-357" />
    <line x1="30" y1="18.5" x2="30" y2="20.5" data-id="element-358" />
    <line x1="34" y1="20" x2="35" y2="22" data-id="element-359" />
  </svg>;
export const BasketballIcon = ({
  className,
  strokeWidth = 1.5
}: IconProps) => <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-360">
    <circle cx="24" cy="24" r="16" fill="currentColor" fillOpacity="0.1" data-id="element-361" />
    <circle cx="24" cy="24" r="16" data-id="element-362" />
    <line x1="24" y1="8" x2="24" y2="40" data-id="element-363" />
    <line x1="8" y1="24" x2="40" y2="24" data-id="element-364" />
    <path d="M12 13 Q20 24 12 35" data-id="element-365" />
    <path d="M36 13 Q28 24 36 35" data-id="element-366" />
  </svg>;
export const VolleyballIcon = ({
  className,
  strokeWidth = 1.5
}: IconProps) => <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-367">
    <circle cx="24" cy="24" r="16" fill="currentColor" fillOpacity="0.08" data-id="element-368" />
    <circle cx="24" cy="24" r="16" data-id="element-369" />
    <path d="M24 8 Q14 24 24 40" data-id="element-370" />
    <path d="M24 8 Q34 24 24 40" data-id="element-371" />
    <path d="M8 24 Q24 14 40 24" data-id="element-372" />
    <path d="M8 24 Q24 34 40 24" data-id="element-373" />
  </svg>;
export const FootballIcon = ({
  className,
  strokeWidth = 1.5
}: IconProps) => <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-374">
    <path d="M8 24 Q12 10 24 10 Q36 10 40 24 Q36 38 24 38 Q12 38 8 24 Z" fill="currentColor" fillOpacity="0.1" data-id="element-375" />
    <path d="M8 24 Q12 10 24 10 Q36 10 40 24 Q36 38 24 38 Q12 38 8 24 Z" data-id="element-376" />
    <line x1="18" y1="24" x2="30" y2="24" data-id="element-377" />
    <line x1="20" y1="21" x2="20" y2="27" data-id="element-378" />
    <line x1="24" y1="20" x2="24" y2="28" data-id="element-379" />
    <line x1="28" y1="21" x2="28" y2="27" data-id="element-380" />
  </svg>;